__turbopack_context__.v({
  "slientDashboardMobileSegments": "ClientDashboardMobileSegments-module__FMBx3G__slientDashboardMobileSegments",
});
